export const URL_HELPDESK_ACCESS = 'https://humansinc.atlassian.net/servicedesk/customer/portal/8';
export default {};
